export const colors: { [key: string]: string } = {
  '1C Enterprise': '#814CCC',
  ABAP: '#E8274B',
  'ABAP CDS': '#555e25',
  'AGS Script': '#B9D9FF',
  AIDL: '#34EB6B',
  AL: '#3AA2B5',
  AMPL: '#E6EFBB',
  ANTLR: '#9DC3FF',
  'API Blueprint': '#2ACCA8',
  APL: '#5A8164',
  'ASP.NET': '#9400ff',
  ATS: '#1ac620',
  ActionScript: '#882B0F',
  Ada: '#02f88c',
  Agda: '#315665',
  Alloy: '#64C800',
  AngelScript: '#C7D7DC',
  Apex: '#1797c0',
  'Apollo Guidance Computer': '#0B3D91',
  AppleScript: '#101F1F',
  Arc: '#aa2afe',
  AspectJ: '#a957b0',
  Assembly: '#6E4C13',
  Asymptote: '#ff0000',
  AutoHotkey: '#6594b9',
  AutoIt: '#1C3552',
  Awk: '#c30e9b',
  BASIC: '#ff0000',
  Ballerina: '#FF5000',
  Batchfile: '#C1F12E',
  Beef: '#a52f4e',
  Bicep: '#519aba',
  Bison: '#6A463F',
  Blade: '#f7523f',
  BlitzMax: '#cd6400',
  Boo: '#d4bec1',
  Boogie: '#c80fa0',
  Brainfuck: '#2F2530',
  Browserslist: '#ffd539',
  C: '#555555',
  'C#': '#178600',
  'C++': '#f34b7d',
  CSON: '#244776',
  CSS: '#563d7c',
  CUE: '#5886E1',
  Ceylon: '#dfa535',
  Chapel: '#8dc63f',
  Cirru: '#ccccff',
  Clarion: '#db901e',
  'Classic ASP': '#6a40fd',
  Clean: '#3F85AF',
  Click: '#E4E6F3',
  Clojure: '#db5855',
  'Closure Templates': '#0d948f',
  CoffeeScript: '#244776',
  ColdFusion: '#ed2cd6',
  'ColdFusion CFC': '#ed2cd6',
  'Common Lisp': '#3fb68b',
  'Common Workflow Language': '#B5314C',
  'Component Pascal': '#B0CE4E',
  Crystal: '#000100',
  Cuda: '#3A4E3A',
  D: '#ba595e',
  DM: '#447265',
  Dafny: '#FFEC25',
  Dart: '#00B4AB',
  DataWeave: '#003a52',
  Dhall: '#dfafff',
  Dockerfile: '#384d54',
  Dogescript: '#cca760',
  Dylan: '#6c616e',
  E: '#ccce35',
  ECL: '#8a1267',
  EJS: '#a91e50',
  EQ: '#a78649',
  Eiffel: '#4d6977',
  Elixir: '#6e4a7e',
  Elm: '#60B5CC',
  'Emacs Lisp': '#c065db',
  EmberScript: '#FFF4F3',
  Erlang: '#B83998',
  'F#': '#b845fc',
  'F*': '#572e30',
  FLUX: '#88ccff',
  Factor: '#636746',
  Fancy: '#7b9db4',
  Fantom: '#14253c',
  Faust: '#c37240',
  Fluent: '#ffcc33',
  Forth: '#341708',
  Fortran: '#4d41b1',
  FreeBasic: '#867db1',
  FreeMarker: '#0050b2',
  Frege: '#00cafe',
  Futhark: '#5f021f',
  'G-code': '#D08CF2',
  GAML: '#FFC766',
  GDScript: '#355570',
  'Game Maker Language': '#71b417',
  'Gemfile.lock': '#701516',
  Genie: '#fb855d',
  Gherkin: '#5B2063',
  Glyph: '#c1ac7f',
  Gnuplot: '#f0a9f0',
  Go: '#00ADD8',
  Golo: '#88562A',
  Gosu: '#82937f',
  'Grammatical Framework': '#ff0000',
  GraphQL: '#e10098',
  Groovy: '#e69f56',
  HTML: '#e34c26',
  Hack: '#878787',
  Haml: '#ece2a9',
  Handlebars: '#f7931e',
  Harbour: '#0e60e3',
  Haskell: '#5e5086',
  Haxe: '#df7900',
  HiveQL: '#dce200',
  HolyC: '#ffefaf',
  Hy: '#7790B2',
  IDL: '#a3522f',
  'IGOR Pro': '#0000cc',
  Idris: '#b30000',
  'ImageJ Macro': '#99AAFF',
  Io: '#a9188d',
  Ioke: '#078193',
  Isabelle: '#FEFE00',
  J: '#9EEDFF',
  JFlex: '#DBCA00',
  JSONiq: '#40d47e',
  Java: '#b07219',
  JavaScript: '#f1e05a',
  Jinja: '#a52a22',
  Jolie: '#843179',
  Jsonnet: '#0064bd',
  Julia: '#a270ba',
  'Jupyter Notebook': '#DA5B0B',
  KRL: '#28430A',
  'Kaitai Struct': '#773b37',
  Kotlin: '#A97BFF',
  LFE: '#4C3023',
  LLVM: '#185619',
  LOLCODE: '#cc9900',
  LSL: '#3d9970',
  Lark: '#2980B9',
  Lasso: '#999999',
  Latte: '#f2a542',
  Less: '#1d365d',
  Lex: '#DBCA00',
  LilyPond: '#9ccc7c',
  Liquid: '#67b8de',
  LiveScript: '#499886',
  LookML: '#652B81',
  Lua: '#000080',
  MATLAB: '#e16737',
  MAXScript: '#00a6a6',
  MLIR: '#5EC8DB',
  MQL4: '#62A8D6',
  MQL5: '#4A76B8',
  MTML: '#b7e1f4',
  Macaulay2: '#d8ffff',
  Makefile: '#427819',
  Markdown: '#083fa1',
  Marko: '#42bff2',
  Mask: '#f97732',
  Max: '#c4a79c',
  Mercury: '#ff2b2b',
  Meson: '#007800',
  Metal: '#8f14e9',
  Mirah: '#c7a938',
  'Modula-3': '#223388',
  Mustache: '#724b3b',
  NCL: '#28431f',
  NWScript: '#111522',
  Nearley: '#990000',
  Nemerle: '#3d3c6e',
  NetLinx: '#0aa0ff',
  'NetLinx+ERB': '#747faa',
  NetLogo: '#ff6375',
  NewLisp: '#87AED7',
  Nextflow: '#3ac486',
  Nim: '#ffc200',
  Nit: '#009917',
  Nix: '#7e7eff',
  Nu: '#c9df40',
  NumPy: '#9C8AF9',
  Nunjucks: '#3d8137',
  OCaml: '#3be133',
  ObjectScript: '#424893',
  'Objective-C': '#438eff',
  'Objective-C++': '#6866fb',
  'Objective-J': '#ff0c5a',
  Odin: '#60AFFE',
  Omgrofl: '#cabbff',
  Opal: '#f7ede0',
  OpenQASM: '#AA70FF',
  Org: '#77aa99',
  Oxygene: '#cdd0e3',
  Oz: '#fab738',
  P4: '#7055b5',
  'PEG.js': '#234d6b',
  PHP: '#4F5D95',
  PLSQL: '#dad8d8',
  Pan: '#cc0000',
  Papyrus: '#6600cc',
  Parrot: '#f3ca0a',
  Pascal: '#E3F171',
  Pawn: '#dbb284',
  Pep8: '#C76F5B',
  Perl: '#0298c3',
  PigLatin: '#fcd7de',
  Pike: '#005390',
  PogoScript: '#d80074',
  PostScript: '#da291c',
  PowerBuilder: '#8f0f8d',
  PowerShell: '#012456',
  Prisma: '#0c344b',
  Processing: '#0096D8',
  Prolog: '#74283c',
  'Propeller Spin': '#7fa2a7',
  Pug: '#a86454',
  Puppet: '#302B6D',
  PureBasic: '#5a6986',
  PureScript: '#1D222D',
  Python: '#3572A5',
  'Q#': '#fed659',
  QML: '#44a51c',
  'Qt Script': '#00b841',
  Quake: '#882233',
  R: '#198CE7',
  RAML: '#77d9fb',
  RUNOFF: '#665a4e',
  Racket: '#3c5caa',
  Ragel: '#9d5200',
  Raku: '#0000fb',
  Rascal: '#fffaa0',
  ReScript: '#ed5051',
  Reason: '#ff5847',
  Rebol: '#358a5b',
  'Record Jar': '#0673ba',
  Red: '#f50000',
  'Regular Expression': '#009a00',
  "Ren'Py": '#ff7f7f',
  Ring: '#2D54CB',
  Riot: '#A71E49',
  Roff: '#ecdebe',
  Rouge: '#cc0088',
  Ruby: '#701516',
  Rust: '#dea584',
  SAS: '#B34936',
  SCSS: '#c6538c',
  SQF: '#3F3F3F',
  'SRecode Template': '#348a34',
  SVG: '#ff9900',
  SaltStack: '#646464',
  Sass: '#a53b70',
  Scala: '#c22d40',
  Scaml: '#bd181a',
  Scheme: '#1e4aec',
  Self: '#0579aa',
  Shell: '#89e051',
  Shen: '#120F14',
  Singularity: '#64E6AD',
  Slash: '#007eff',
  Slice: '#003fa2',
  Slim: '#2b2b2b',
  SmPL: '#c94949',
  Smalltalk: '#596706',
  Solidity: '#AA6746',
  SourcePawn: '#f69e1d',
  Squirrel: '#800000',
  Stan: '#b2011d',
  'Standard ML': '#dc566d',
  Starlark: '#76d275',
  StringTemplate: '#3fb34f',
  Stylus: '#ff6347',
  SuperCollider: '#46390b',
  Svelte: '#ff3e00',
  Swift: '#ffac45',
  SystemVerilog: '#DAE1C2',
  'TI Program': '#A0AA87',
  Tcl: '#e4cc98',
  TeX: '#3D6117',
  Terra: '#00004c',
  'TextMate Properties': '#df66e4',
  Turing: '#cf142b',
  Twig: '#c1d026',
  TypeScript: '#2b7489',
  'Unified Parallel C': '#4e3617',
  Uno: '#9933cc',
  UnrealScript: '#a54c4d',
  V: '#4f87c4',
  VBA: '#867db1',
  VBScript: '#15dcdc',
  VCL: '#148AA8',
  VHDL: '#adb2cb',
  Vala: '#fbe5cd',
  'Valve Data Format': '#f26025',
  Verilog: '#b2b7f8',
  'Vim script': '#199f4b',
  'Visual Basic .NET': '#945db7',
  Volt: '#1F1F1F',
  Vue: '#41b883',
  WebAssembly: '#04133b',
  Wollok: '#a23738',
  X10: '#4B6BEF',
  XC: '#99DA07',
  XQuery: '#5232e7',
  XSLT: '#EB8CEB',
  Xonsh: '#285EEF',
  YAML: '#cb171e',
  YARA: '#220000',
  YASnippet: '#32AB90',
  Yacc: '#4B6C4B',
  ZAP: '#0d665e',
  ZIL: '#dc75e5',
  ZenScript: '#00BCD1',
  Zephir: '#118f9e',
  Zig: '#ec915c',
  eC: '#913960',
  jq: '#c7254e',
  'mIRC Script': '#3d57c3',
  mcfunction: '#E22837',
  nesC: '#94B0C7',
  ooc: '#b0b77e',
  q: '#0040cd',
  sed: '#64b970',
  wdl: '#42f1f4',
  wisp: '#7582D1',
  xBase: '#403a40',
}
